var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xc-spin"},[(_vm.SpinStatus)?_c('Spin',{attrs:{"fix":"","size":"large"}},[_c('Icon',{staticClass:"demo-spin-icon-load",attrs:{"type":"ios-loading","size":"30"}}),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"10px"}},[_vm._v("加载中...")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }